import { defineComponent as t, useSlots as r, createBlock as p, openBlock as s, mergeProps as i, unref as n, withCtx as u, renderSlot as d } from "vue";
import f from "../Label/LabelGroup.vue2.js";
import { useOUIAProps as m } from "../../helpers/ouia.js";
const C = /* @__PURE__ */ t({
  name: "PfChipGroup",
  __name: "ChipGroup",
  props: {
    id: {},
    numChips: { default: 3 },
    closeBtnAriaLabel: { default: "Close chip group" },
    ariaLabel: { default: "Chip group category" },
    expandedText: { default: "Show Less" },
    collapsedText: { default: "${remaining} more" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(o) {
    const a = o, l = m({ id: a.ouiaId, safe: a.ouiaSafe });
    return r(), (e, c) => (s(), p(f, i(n(l), {
      "num-labels": e.numChips,
      "close-btn-aria-label": e.closeBtnAriaLabel,
      "aria-label": e.ariaLabel,
      "expanded-text": e.expandedText,
      "collapsed-text": e.collapsedText
    }), {
      default: u(() => [
        d(e.$slots, "default")
      ]),
      _: 3
    }, 16, ["num-labels", "close-btn-aria-label", "aria-label", "expanded-text", "collapsed-text"]));
  }
});
export {
  C as default
};
